import { monochrome } from '@vyce/core/src/theme/styles';

export const defaultLocationOption = { value: 'all', name: 'All Locations' };
export const defaultSelectedLocationOption = { value: 'selected', name: 'Selected Locations' };
export const defaultStatusOption = {
  value: 'all',
  name: 'any status',
};

export const statusesEnum = {
  all: 'all',
  clocked_in: 'clocked_in',
  clocked_out: 'clocked_out',
  not_clocked_in_today: 'not_clocked_in_today',
  not_clocked_in_today_anywhere: 'not_clocked_in_today_anywhere',
};
export const statuses = {
  all: 'any status',
  clocked_in: 'Clocked In',
  clocked_out: 'Clocked Out',
  not_clocked_in_today: 'Hasn’t clocked in today on this location',
  not_clocked_in_today_anywhere: 'Hasn’t clocked in today on any location',
} as const;

export const statusOptions = [
  defaultStatusOption,
  {
    value: statusesEnum.clocked_in,
    name: statuses.clocked_in,
  },
  {
    value: statusesEnum.clocked_out,
    name: statuses.clocked_out,
  },
  {
    value: statusesEnum.not_clocked_in_today,
    name: statuses.not_clocked_in_today,
  },
  {
    value: statusesEnum.not_clocked_in_today_anywhere,
    name: statuses.not_clocked_in_today_anywhere,
  },
];

export const maxBarHeight = 40;
export const barNames = {
  not_clocked_in_today: 'not_clocked_in_today',
  clocked_in: 'clocked_in',
  clocked_out: 'clocked_out',
  not_clocked_in_today_anywhere: 'not_clocked_in_today_anywhere',
};
export type Names = keyof typeof barNames;
export const colors: Record<Names, { lightColor: string; darkColor: string }> = {
  clocked_in: { lightColor: '#610BEF', darkColor: '#610BEF' },
  clocked_out: { lightColor: monochrome.mediumdark, darkColor: monochrome.dark },
  not_clocked_in_today: { lightColor: '#EAAC30', darkColor: '#EAAC30' },
  not_clocked_in_today_anywhere: { lightColor: monochrome.mediumlight, darkColor: monochrome.mediumdark },
};

export const keys = Object.keys(barNames);
